import { Link } from "react-router-dom";
import { ArrowRight, Gift } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";

export function VantaggiTeaser() {
  const { user } = useAuth();
  const { loginEnabled, loaded } = useSettings();
  if (user || !loaded || !loginEnabled) return null;
  return (
    <aside data-testid="vantaggi-teaser" className="mt-8 relative overflow-hidden rounded-2xl border border-brand/30 bg-brandTertiary/30 p-5 sm:p-6">
      <span aria-hidden className="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-brand/10" />
      <div className="relative flex flex-col sm:flex-row sm:items-center gap-4">
        <span className="shrink-0 w-11 h-11 rounded-full bg-brand text-onBrand flex items-center justify-center"><Gift size={20} /></span>
        <div className="flex-1">
          <p className="font-serif text-xl font-semibold text-onSurface leading-snug">Ti è piaciuto? Con Readoo informarti vale di più.</p>
          <p className="mt-1 text-sm text-onSurfaceSecondary">Iscriviti gratis e accedi ai vantaggi Premium riservati ai lettori Readoo.</p>
        </div>
        <Link to="/vantaggi" data-testid="vantaggi-teaser-cta" className="group shrink-0 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-brand text-onBrand text-sm font-bold uppercase tracking-wide hover:bg-brandSecondary transition-colors">
          Scopri i vantaggi <ArrowRight size={16} className="transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
    </aside>
  );
}

export function HomeSignupBand() {
  const { user } = useAuth();
  const { loginEnabled, loaded } = useSettings();
  if (user || !loaded || !loginEnabled) return null;
  return (
    <div data-testid="home-signup-band" className="border-b border-hair bg-brandTertiary/30">
      <div className="max-w-[1200px] mx-auto px-3 sm:px-6 lg:px-8 py-2.5 flex items-center gap-1.5 sm:gap-3">
        <Gift size={18} className="hidden sm:block text-brand shrink-0" />
        <Gift size={15} className="sm:hidden text-brand shrink-0" />
        <p className="hidden sm:block flex-1 min-w-0 text-sm leading-snug text-onSurface">
          <span className="font-semibold">Registrati:</span> vantaggi oggi, Readoo Punti presto.{" "}
          <Link to="/vantaggi" data-testid="home-signup-band-more" className="font-semibold text-brand hover:underline">Scopri di più</Link>
        </p>
        <Link to="/vantaggi" data-testid="home-signup-band-more-mobile" className="sm:hidden flex-1 min-w-0 truncate text-[13px] text-onSurface">
          Vantaggi oggi, Punti presto.{" "}
          <span className="font-semibold text-brand underline underline-offset-2">Scopri</span>
        </Link>
        <Link to="/registrati" data-testid="home-signup-band-cta" className="shrink-0 inline-flex items-center gap-1.5 px-3 sm:px-4 py-2 rounded-full bg-brand text-onBrand text-[11px] sm:text-sm font-bold hover:bg-brandSecondary transition-colors">
          Iscriviti gratis
        </Link>
      </div>
    </div>
  );
}
